import { CustomIcon } from 'modules/components/layer00';
import React, { ReactNode } from 'react';

import * as ds from './dataService';
import {
  Box,
  Stack,
  Typography,
  useTheme
} from '@mui/material';

import { useParams } from 'react-router-dom';



export type UserDetailCardProps = {};


/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: UserDetailCardProps) => {
  const params = useParams();
  const theme = useTheme();
  const { data } = ds.useQuery(params.personId ?? '');

  return (
    <Box
      display='flex'
      flexDirection='column'
      rowGap='1rem'
    >
      {fields.map((node, i) => {
        const Icon = field2Icon[node];
        return (
          <Stack
            key={i}
            direction='row'
            columnGap='.5rem'
            alignItems='center'
          >
            <Icon
              stroke={theme.palette.primary.main}
            />
            <Typography variant='formLabel'>{field2Label[node]}</Typography>
            <Typography variant='formInput'>{data[node]}</Typography>

          </Stack>
        );
      })}
    </Box>
  );
};


const fields: (keyof Omit<ds.IData, 'id'>)[] = [
  'firstName',
  'lastName',
  'phoneNumber',
  'preferredEmail',
  'createdDate'
];



const field2Label: Record<typeof fields[number], string> = {
  firstName: 'First Name',
  lastName: 'Last Name',
  phoneNumber: 'Phone Number',
  preferredEmail: 'Preferred Email',
  createdDate: 'Created Date'
};

const field2Icon: Record<typeof fields[number], ({ stroke }: { stroke: string }) => ReactNode> = {
  firstName: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='DOC' stroke={stroke} />,
  lastName: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='DOC' stroke={stroke} />,
  phoneNumber: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='INFO' stroke={stroke} />,
  preferredEmail: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='MESSAGES' stroke={stroke} />,
  createdDate: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='CLOCK' stroke={stroke} />
};
